import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const GridIndex = lazy(() => import('./Index'))

export const HotelRouter = React.memo(() => (
  <SubRouter loggedIn>
    <Route path='*' element={<GridIndex />} />
  </SubRouter>
))
